import React, { useState } from 'react';
import { Bookmark, BookmarkCheck, Loader2 } from 'lucide-react';
import { saveToStack, removeFromStack } from '../lib/supabase';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './SaveButton.css';

export default function SaveButton({ toolId, initialSaved = false, size = 'md' }) {
  const [saved, setSaved] = useState(initialSaved);
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleToggle = async (e) => {
    e.preventDefault(); // don't follow parent <a> links
    e.stopPropagation();

    // Not logged in — send to signup
    if (!user) {
      navigate('/signup');
      return;
    }

    setLoading(true);
    try {
      if (saved) {
        await removeFromStack(toolId);
        setSaved(false);
      } else {
        await saveToStack(toolId);
        setSaved(true);
      }
    } catch (err) {
      console.error('Stack toggle error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      className={`save-btn save-btn--${size} ${saved ? 'save-btn--saved' : ''}`}
      onClick={handleToggle}
      aria-label={saved ? 'Remove from stack' : 'Save to stack'}
      title={saved ? 'Remove from My Stack' : 'Save to My Stack'}
      disabled={loading}
    >
      {loading ? (
        <Loader2 size={size === 'sm' ? 13 : 15} className="save-btn__spin" />
      ) : saved ? (
        <BookmarkCheck size={size === 'sm' ? 13 : 15} />
      ) : (
        <Bookmark size={size === 'sm' ? 13 : 15} />
      )}
    </button>
  );
}
